import { render, staticRenderFns } from "./SlideItem.vue?vue&type=template&id=fa76642a&scoped=true&"
import script from "./SlideItem.vue?vue&type=script&lang=js&"
export * from "./SlideItem.vue?vue&type=script&lang=js&"
import style0 from "./SlideItem.vue?vue&type=style&index=0&id=fa76642a&prod&lang=scss&"
import style1 from "./SlideItem.vue?vue&type=style&index=1&id=fa76642a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76642a",
  null
  
)

export default component.exports